import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { URL_LIST_ALL } from "../configs/api";
import Axios from "axios";
import Moment from "react-moment";
import { confirmAlert } from "react-confirm-alert";
import NumberInput from "../component/NumberInput";
import SearchBoxModal from "../component/SearchBoxModal";
import Spinner from "../component/Spinner";

export default function GroupPayment({ purchasingId, purchasingInfo = null, groupId = null, paymentLenght, onChange, payments = null, selectRow = [], onSelectRow }) {
    const { user } = useSelector((state) => state.auth);
    const [groupTitle, setGroupTitle] = useState(purchasingInfo && purchasingInfo.title ? purchasingInfo.title : "");
    const [valuePayment, setValuePayment] = useState(null)
    const [valueEdit, setValueEdit] = useState(null)
    const [editIndex, setEditIndex] = useState(null)
    const [onLoading, setOnLoading] = useState(null)

    const defaultdetail = {
        group_id: groupId,
        title: "",
        description: "",
        number: "",
        dongia: "",
        tientruocvat: "",
        tiensauvat: "",
        vat: "",
        payment_date: "",
        supplier_id: 0,
        status: false,
    }

    const actionGroup = () => {
        if (!groupTitle) {
            alert("Vui lòng nhập tên tiến trình")
            return null
        }
        let data_save = {
            purchasing_id: purchasingId,
            title: groupTitle,
            status: 1,
        }
        if (groupId && groupId > 0) {
            setOnLoading(1)
            Axios.put(URL_LIST_ALL + 'purchasing_walking_group/' + groupId, data_save, user.config).then(res => {
                setOnLoading(null)
                if (res.data.status == "success") {
                    onChange(res.data.id)
                } else {
                    confirmAlert({
                        title: 'Lỗi',
                        message: res.data.message,
                        buttons: [{ label: 'OK' }]
                    });
                }
            }).catch(err => console.log(err));
        } else {
            setOnLoading(1)
            Axios.post(URL_LIST_ALL + 'purchasing_walking_group', data_save, user.config).then(res => {
                setOnLoading(null)
                if (res.data.status == "success") {
                    onChange(res.data.id)
                } else {
                    confirmAlert({
                        title: 'Lỗi',
                        message: res.data.message,
                        buttons: [{ label: 'OK' }]
                    });
                }
            }).catch(err => console.log(err));
        }
    }

    const actionPayment = (pay_id = null) => {
        if (pay_id && valueEdit) {
            if (valueEdit.id && valueEdit.id > 0) {
                if (!valueEdit.title) {
                    alert("Vui lòng nhập nội dung")
                    return null
                }
                setOnLoading(2)
                Axios.put(URL_LIST_ALL + 'purchasing_walking_item/' + valueEdit.id, valueEdit, user.config).then(res => {
                    setOnLoading(null)
                    if (res.data.status == "success") {
                        onChange(res.data.time)
                        setValueEdit(null)
                    } else {
                        confirmAlert({
                            title: 'Lỗi',
                            message: res.data.message,
                            buttons: [{ label: 'OK' }]
                        });
                    }
                }).catch(err => console.log(err));
            }
        } else if (valuePayment) {
            if (!valuePayment.title) {
                alert("Vui lòng nhập nội dung")
                return null
            }
            setOnLoading(2)
            Axios.post(URL_LIST_ALL + 'purchasing_walking_item', valuePayment, user.config).then(res => {
                setOnLoading(null)
                if (res.data.status == "success") {
                    onChange(res.data.time)
                    setValuePayment(null)
                } else {
                    confirmAlert({
                        title: 'Lỗi',
                        message: res.data.message,
                        buttons: [{ label: 'OK' }]
                    });
                }
            }).catch(err => console.log(err));
        }
    }

    const onDeletePayment = (id) => {
        confirmAlert({
            title: 'Cảnh báo',
            message: 'Bạn muốn xóa mục này ?',
            buttons: [{
                label: 'OK', onClick: (() => {
                    Axios.delete(URL_LIST_ALL + 'purchasing_walking_item/' + id, user.config).then(res => {
                        if (res.data.status == "success") {
                            onChange(res.data.time)
                        } else {
                            confirmAlert({
                                title: 'Lỗi',
                                message: res.data.message,
                                buttons: [{ label: 'OK' }]
                            });
                        }
                    }).catch(err => console.log(err));
                })
            }]
        });
    }
    const deleteGroup = (id) => {
        confirmAlert({
            title: 'Cảnh báo',
            message: 'Bạn muốn xóa danh mục này ?',
            buttons: [{
                label: 'OK', onClick: (() => {
                    Axios.delete(URL_LIST_ALL + 'purchasing_walking_group/' + id, user.config).then(res => {
                        if (res.data.status == "success") {
                            onChange(res.data.time)
                        } else {
                            confirmAlert({
                                title: 'Lỗi',
                                message: res.data.message,
                                buttons: [{ label: 'OK' }]
                            });
                        }
                    }).catch(err => console.log(err));
                })
            }]
        });
    }

    return (<div className="card card-payment mt-2 mb-3">
        <div className="card-body p-1">
            <div className="input-group mb-2">
                <div className="input-group-prepend">
                    <h4 className="input-group-text">
                        <strong>{(paymentLenght && paymentLenght > 0) ? paymentLenght + 1 : 1}. </strong>
                    </h4>
                </div>
                <input type="text" className="form-control h-auto border-top border-bottom" placeholder="Nhập tên danh mục"
                    onChange={(e) => setGroupTitle(e.target.value)} value={groupTitle} />
                <div className="input-group-prepend">
                    <button type="button" className="btn btn-info"
                        onClick={() => {
                            actionGroup()
                        }}>
                        {onLoading && onLoading == 1 ? <Spinner /> : <span className="fas fa-save"></span>}
                    </button>
                </div>
                <div className="input-group-prepend">
                    {(groupId && !valuePayment) && <button className="ml-2 btn btn-sm btn-danger" type="button" onClick={() => deleteGroup(groupId)}>
                        <span className="fas fa-trash-alt"></span>
                    </button>}
                </div>
                <div className="input-group-prepend">
                    {(!groupId) && <button className="ml-2 btn btn-sm btn-danger" type="button" onClick={() => onChange("delete")}>
                        <span className="fas fa-trash-alt"></span>
                    </button>}
                </div>

            </div>
            <div className="w-100 out-table">
                <table className="table table-bordered table-hover">
                    <thead className="thead-dark">
                        <tr>
                            <th style={{ width: "50px" }}>
                                <div className="w-100 d-flex align-items-center">
                                    <input
                                        type="checkbox"
                                        checked={
                                            payments &&
                                            payments.length > 0 &&
                                            payments.every(p => selectRow.includes(p.id))
                                        }
                                        onChange={(e) => {
                                            if (!payments) return;

                                            if (e.target.checked) {
                                                // select all trong group
                                                const ids = payments.map(p => p.id);
                                                const newSelected = Array.from(new Set([...selectRow, ...ids]));
                                                onSelectRow(newSelected);
                                            } else {
                                                // unselect all trong group
                                                const ids = payments.map(p => p.id);
                                                onSelectRow(selectRow.filter(id => !ids.includes(id)));
                                            }
                                        }}
                                    />
                                    <span className="ml-1">
                                        Stt
                                    </span>
                                </div>
                                
                            </th>
                            <th style={{ minWidth: "250px" }}>Nội dung</th>
                            <th style={{ minWidth: "70px" }}>SL</th>
                            <th style={{ minWidth: "150px" }}>Đơn giá</th>
                            <th style={{ minWidth: "120px" }}>Giá trước VAT</th>
                            <th style={{ minWidth: "120px" }}>VAT</th>
                            <th style={{ minWidth: "120px" }}>Giá sau VAT</th>
                            <th style={{ minWidth: "120px" }}>Nhà CC</th>
                            <th style={{ width: "150px" }}>Thời gian</th>
                            <th style={{ width: "150px" }}>Trạng thái</th>
                            <th>#</th>
                        </tr>
                    </thead>
                    <tbody>
                        {(payments && payments.length > 0) && (
                            payments.map((p, index) => (
                                <tr key={index}>
                                    <td>
                                        <div className="w-100 d-flex align-items-center">
                                            <input
                                                type="checkbox"
                                                checked={selectRow.includes(p.id)}
                                                onChange={() => {
                                                    if (selectRow.includes(p.id)) {
                                                        // bỏ chọn
                                                        onSelectRow(selectRow.filter(id => id !== p.id));
                                                    } else {
                                                        // chọn
                                                        onSelectRow([...selectRow, p.id]);
                                                    }
                                                }}
                                            />

                                            <span className="ml-1">{index + 1}</span>
                                        </div>
                                    </td>
                                    <td>
                                        {editIndex == p.id && valueEdit && valueEdit.id == p.id ?
                                            <>
                                                <textarea type="text" className="pl-1 pr-1 form-control form-control-sm" placeholder="Nội dung"
                                                    value={valueEdit.title} onChange={(e) => setValueEdit({ ...valueEdit, title: e.target.value })} ></textarea>

                                                <textarea type="text" className="pl-1 pr-1 form-control form-control-sm" placeholder="Ghi chú"
                                                    value={valueEdit.description} onChange={(e) => setValueEdit({ ...valueEdit, description: e.target.value })}></textarea>
                                            </>
                                            :
                                            <>
                                                <strong>{p.title}</strong><br />
                                                <small>{p.description ? "Ghi chú: " + p.description : ""}</small>
                                            </>
                                        }
                                    </td>
                                    <td>
                                        {editIndex == p.id && valueEdit && valueEdit.id == p.id ?
                                            <input type="text" className="pl-1 pr-1 form-control form-control-sm" placeholder="Số lượng"
                                                value={valueEdit.number} onChange={(e) => setValueEdit({ ...valueEdit, number: e.target.value })} />
                                            :
                                            (p.number ? p.number : 0)
                                        }
                                    </td>
                                    <td>
                                        {editIndex == p.id && valueEdit && valueEdit.id == p.id ?
                                            <NumberInput
                                                className="pl-1 pr-1 form-control form-control-sm"
                                                value={valueEdit.dongia}
                                                onChange={(e) => setValueEdit({ ...valueEdit, dongia: e })}
                                                placeholder="Đơn giá"
                                            />
                                            :
                                            p.dongia.toLocaleString("vi-VN") + " đ"
                                        }
                                    </td>
                                    <td>
                                        {editIndex == p.id && valueEdit && valueEdit.id == p.id ?
                                            <NumberInput
                                                className="pl-1 pr-1 form-control form-control-sm"
                                                value={valueEdit.tientruocvat}
                                                onChange={(e) => setValueEdit({ ...valueEdit, tientruocvat: e })}
                                                placeholder="Tiền trước VAT"
                                            />
                                            :
                                            p.tientruocvat.toLocaleString("vi-VN") + " đ"
                                        }
                                    </td>
                                    <td>
                                        {editIndex == p.id && valueEdit && valueEdit.id == p.id ?
                                            <NumberInput
                                                className="pl-1 pr-1 form-control form-control-sm"
                                                value={valueEdit.vat}
                                                onChange={(e) => setValueEdit({ ...valueEdit, vat: e })}
                                                placeholder="VAT"
                                            />
                                            :
                                            p.vat.toLocaleString("vi-VN") + " đ"
                                        }

                                    </td>
                                    <td>
                                        {editIndex == p.id && valueEdit && valueEdit.id == p.id ?
                                            <NumberInput
                                                className="pl-1 pr-1 form-control form-control-sm"
                                                value={valueEdit.tiensauvat}
                                                onChange={(e) => setValueEdit({ ...valueEdit, tiensauvat: e })}
                                                placeholder="Sau VAT"
                                            />
                                            :
                                            p.tiensauvat.toLocaleString("vi-VN") + " đ"
                                        }
                                    </td>
                                    <td>
                                        {editIndex == p.id && valueEdit && valueEdit.id == p.id ?
                                            <SearchBoxModal apiname={"purchasing_supplier"} placeholder="Chọn nhà CC" colvalue={'id'} colname={'title'}
                                                buttonLabel={<span className="fas fa-plus-square"></span>}
                                                defaultValue={valueEdit.supplier_id} name='supplier_id'
                                                onChange={async (e) => {
                                                    await setValueEdit({ ...valueEdit, supplier_id: e })
                                                }}></SearchBoxModal>
                                            :
                                            p.supplier_name
                                        }
                                    </td>
                                    <td>
                                        {editIndex == p.id && valueEdit && valueEdit.id == p.id ?
                                            <input
                                                type="date"
                                                className="pl-1 pr-1 form-control form-control-sm"
                                                value={valueEdit.payment_date} onChange={(e) => setValueEdit({ ...valueEdit, payment_date: e.target.value })}
                                            />
                                            :
                                            (p.payment_date ? <Moment format="DD/MM/YYYY">{p.payment_date}</Moment> : "")
                                        }
                                    </td>
                                    <td>
                                        {editIndex == p.id && valueEdit && valueEdit.id == p.id ?
                                            <select
                                                className="pl-1 pr-1 form-select form-select-sm"
                                                value={valueEdit.status} onChange={(e) => setValueEdit({ ...valueEdit, status: e.target.value })}
                                            >
                                                <option value="0">Chưa thanh toán</option>
                                                <option value="1">Đã thanh toán</option>
                                            </select>
                                            :
                                            <p className={`${p.status ? "text-success" : "text-warning"}`}>
                                                {p.status ? "Đã thanh toán" : "Chưa thanh toán"}
                                            </p>
                                        }
                                    </td>
                                    <td>
                                        {editIndex == p.id && valueEdit && valueEdit.id == p.id ?
                                            <div className="w-100 d-flex">
                                                <button className="btn btn-sm btn-success" type="button" onClick={() => actionPayment(p.id)}>
                                                    {onLoading && onLoading == 2 ? <Spinner /> : <span className="fas fa-save"></span>}
                                                </button>
                                                <button className="btn btn-sm btn-danger" type="button" onClick={() => setValueEdit(null)}>
                                                    <span className="far fa-times-circle"></span>
                                                </button>
                                            </div>
                                            :
                                            <div className="w-100 d-flex">
                                                <button className="btn btn-sm btn-warning" type="button"
                                                    onClick={() => {
                                                        setEditIndex(p.id)
                                                        setValueEdit(p)
                                                    }}>
                                                    <span className="fas fa-pencil-alt"></span>
                                                </button>
                                                <button className="btn btn-sm btn-danger" type="button"
                                                    onClick={() => onDeletePayment(p.id)}>
                                                    <span className="fas fa-trash-alt"></span>
                                                </button>

                                            </div>
                                        }
                                    </td>
                                </tr>
                            ))
                        )}
                        {valuePayment &&
                            <tr>
                                <td>{(payments && payments.length && payments.length > 0) ? payments.length + 1 : 1}</td>
                                <td>
                                    <textarea type="text" className="pl-1 pr-1 form-control form-control-sm" placeholder="Nội dung"
                                        value={valuePayment.title} onChange={(e) => setValuePayment({ ...valuePayment, title: e.target.value })} ></textarea>

                                    <textarea type="text" className="pl-1 pr-1 form-control form-control-sm" placeholder="Ghi chú"
                                        value={valuePayment.description} onChange={(e) => setValuePayment({ ...valuePayment, description: e.target.value })}></textarea>
                                </td>
                                <td>
                                    <input type="text" className="pl-1 pr-1 form-control form-control-sm" placeholder="Số lượng"
                                        value={valuePayment.number} onChange={(e) => setValuePayment({ ...valuePayment, number: e.target.value })} />
                                </td>
                                <td>
                                    <NumberInput
                                        className="pl-1 pr-1 form-control form-control-sm"
                                        value={valuePayment.dongia}
                                        onChange={(e) => setValuePayment({ ...valuePayment, dongia: e })}
                                        placeholder="Đơn giá"
                                    />
                                </td>
                                <td>
                                    <NumberInput
                                        className="pl-1 pr-1 form-control form-control-sm"
                                        value={valuePayment.tientruocvat}
                                        onChange={(e) => setValuePayment({ ...valuePayment, tientruocvat: e })}
                                        placeholder="Giá trước VAT"
                                    />
                                </td>
                                <td>
                                    <NumberInput
                                        className="pl-1 pr-1 form-control form-control-sm"
                                        value={valuePayment.vat}
                                        onChange={(e) => setValuePayment({ ...valuePayment, vat: e })}
                                        placeholder="Giá VAT"
                                    />
                                </td>
                                <td>
                                    <NumberInput
                                        className="pl-1 pr-1 form-control form-control-sm"
                                        value={valuePayment.tiensauvat}
                                        onChange={(e) => setValuePayment({ ...valuePayment, tiensauvat: e })}
                                        placeholder="Giá sau VAT"
                                    />

                                </td>

                                <td>
                                    <SearchBoxModal apiname={"purchasing_supplier"} placeholder="Chọn nhà CC" colvalue={'id'} colname={'title'}
                                        buttonLabel={<span className="fas fa-plus-square"></span>}
                                        defaultValue={valuePayment.supplier_id} name='supplier_id'
                                        onChange={async (e) => {
                                            await setValuePayment({ ...valuePayment, supplier_id: e })
                                        }}></SearchBoxModal>
                                </td>
                                <td>
                                    <input
                                        type="date"
                                        className="pl-1 pr-1 form-control form-control-sm"
                                        value={valuePayment.payment_date} onChange={(e) => setValuePayment({ ...valuePayment, payment_date: e.target.value })}
                                    />
                                </td>
                                <td>
                                    <select
                                        className="pl-1 pr-1 form-select form-select-sm"
                                        value={valuePayment.status} onChange={(e) => setValuePayment({ ...valuePayment, status: e.target.value })}
                                    >
                                        <option value="0">Chưa thanh toán</option>
                                        <option value="1">Đã thanh toán</option>
                                    </select>

                                </td>
                                <td>
                                    <div className="w-100 d-flex">
                                        <button className="btn btn-sm btn-success" type="button" onClick={() => actionPayment()}>
                                            {onLoading && onLoading == 2 ? <Spinner /> : <span className="fas fa-save"></span>}
                                        </button>
                                        <button className="btn btn-sm btn-danger" type="button" onClick={() => setValuePayment(null)}>
                                            <span className="far fa-times-circle"></span>
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
            <div className="w-100 text-center">
                {(groupId && !valuePayment) && <button type="button" className="btn btn-sm btn-primary" onClick={() => setValuePayment(defaultdetail)}>
                    <span className="fas fa-plus"></span> Thêm hạng mục
                </button>}
            </div>
        </div>
    </div>)
}